import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"


const PreviousIssuingAgency = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	
	const fieldName = "PreviousIssuingAgency";
	const fieldTitle = "Previous Issuing Agency";
	const LOV = [
		{ key: "", value: "" },
		{ key: "GS1", value: "GS1" },
		{ key: "HIBCC", value: "HIBCC" },
		{ key: "ICCBBA", value: "ICCBBA" },
		{ key: "NDC / NHRIC", value: "NDC / NHRIC" }
	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} forceIsEditing={forceIsEditing} />
	</>											  
}


export default PreviousIssuingAgency;


